import { find } from 'lodash';

class PricingFormController {
    constructor($state, periodsService, eventsService, messageService, moneyService) {
        this.$state = $state;
        this.periodsService = periodsService;
        this.eventsService = eventsService;
        this.messageService = messageService;
        this.moneyService = moneyService;
    }

    $onInit () {
        this.open = [];
        this.loading = true;
        this.eventpopulation = this.eventsService.collectAll().then(response => {
            this.events = response;
            this.loading = false;
        });

        this.currency = this.moneyService.getCurrencyDetails();

        if (this.period.pricing.length > 0) {
            this.period.pricing = this.period.pricing;
            if (this.period.pricing.length === 1) {
                this.open.push(0);
            }
        } else {
            this.addRule();
        }
        if (this.period.pricing) {
            for (let pricing of this.period.pricing) {
                for (let event of pricing.events) {
                    if (event.days && event.days.length) {
                        event.individual = true;
                        let tempdays = {};
                        for (let day in event.days) {
                            tempdays[event.days[day].day] = event.days[day].pricing_value;
                        }
                        event.days = tempdays;
                    }
                }
            }
        }
    }

    onSave () {
        for (let rule in this.period.pricing) {
            for (let event in this.period.pricing[rule].events) {
                this.period.pricing[rule].events[event].event = undefined;
            }
        }

        return this.periodsService.savePricing(this.period)
            .then(response => {
                this.$state.go('app.admin.periods');
                this.messageService.success(`The pricing for period <strong>${this.period.name}</strong> was successfully updated!`);
            })
            .catch((error) => {
                error.data = error.data.original || error.data;
        this.form.$api.setErrors(error.data);

                let sourceElement = Object.keys(error.data);
                let verb = 'created';
                if (this.period.id) {
                    verb = 'updated';
                }
                if (sourceElement.length > 0) {
                    let errors = '';
                    for (let element of sourceElement) {
                        errors += `<li>${this.messageService.formatError(element, error.data[element])}</li>`;
                    }
                    this.messageService.failure(`The pricing <strong>${this.period.name}</strong> could not be successfully ${verb}: <ul>${errors}</ul>`);
                } else {
                    this.messageService.failure(`The pricing <strong>${this.period.name}</strong> could not be successfully ${verb}: ${error.statusText}`);
                }
                this.messageService.push();
            });
    }

    openList (key) {
        let location = this.open.indexOf(key);
        if (location > -1) {
            this.open.splice(location, 1);
        } else {
            this.open.push(key);
        }
    }

    assignEvent (event) {
        if (event.event) {
            event.event_type = event.event.type_raw;
            event.event_id = event.event.id;
            event.event.disabled = !event.event.disabled;
        }
    }

    applyPricing (event, rule, inputvalue = null) {
        let value = (event.individual && !rule.pricing_value ? inputvalue : (rule.pricing_value || event.pricing_value));
        if (event.event) {
            if (value) {
                if (rule.pricing_type && rule.pricing_value) {
                    return this.applyDiscount(rule.pricing_type, value, event.event.base_price);
                } else if (rule.pricing_type && event.pricing_value) {
                    return this.applyDiscount(rule.pricing_type, value, event.event.base_price);
                } else if (event.pricing_type && event.pricing_value) {
                    return this.applyDiscount(event.pricing_type, value, event.event.base_price);
                } else if ((rule.pricing_type || event.pricing_type) && event.individual) {
                    return this.applyDiscount((rule.pricing_type || event.pricing_type), value, event.event.base_price);
                }
            }
            return (event.individual ? event.event.base_price : 'N/A');
        }
    }

    applyDiscount (type, val, amount) {
        let returnval;
        switch (type) {
            case '#':
                returnval = (amount + parseFloat(val)).toFixed(this.currency.decimals);
                return (returnval >= 0 ? returnval : 0);
            case '%':
                returnval = (amount * ((100 + parseFloat(val / this.currency.magnitude)) / 100)).toFixed(this.currency.decimals);
                return (returnval >= 0 ? returnval : 0);
            case '=':
                return (val >= 0 ? parseFloat(val).toFixed(this.currency.decimals) : 0);
        }
    }

    findEvent (event) {
        this.eventpopulation.then(() => event.event = find(this.events, { id: event.event_id, type_raw: event.event_type }));
    }

    showInput (event, rule, type) {
        return (rule.pricing_type && rule.pricing_type === type && rule.pricing_value > 0) ||
            ((rule.pricing_type && !rule.pricing_value) && rule.pricing_type === type) ||
            ((!rule.pricing_type && !rule.pricing_value) && event.pricing_type && event.pricing_type === type);
    }

    nullGlobal (rule) {
        if (!rule.pricing_type) {
            rule.pricing_value = undefined;
        }
    }

    groupBy (item) {
        return item.type_display;
    }

    addRule () {
        this.open.push(this.period.pricing.push({ events: [{}] }) - 1);
    }
}

PricingFormController.$inject = ['$state', 'periodsService', 'eventsService', 'messageService', 'moneyService'];

export default PricingFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/controllers/pricing.form.controller.js